import { PomAnnouncementPeriod } from "../../domain/group/pom-announcement-period";
import { DateWithoutTime } from "../../utils/date.util";
import { IPaginationMetaModel } from "../utils/pagination-meta.model";

export enum GroupContractType {
  Pom = "pom",
}

export interface IGroupContractModel {
  contractNumber: string;
  startDate: DateWithoutTime;
  startDateCurrentBillingType: DateWithoutTime;
  endDate: DateWithoutTime | null;
  type: GroupContractType;
  active: boolean;

  takeBackSystemId?: number | null;
  takeBackSystemName?: string | null;
  pomAnnouncementPeriod?: PomAnnouncementPeriod;
}

export interface IGroupContractListModel {
  pomContracts: IGroupContractModel[];
  meta: IPaginationMetaModel;
}
